import { makeStyles } from '@material-ui/core';
import codearc from '../../assets/codearc.png';

const useStyles = makeStyles({
  container: {
    width: 40,
    height: 40,
    overflow: 'hidden',
    display: 'block',
  },
  logo: {
    height: 40,
    width: 'auto',
    display: 'block',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img className={classes.logo} src={codearc} alt="Codearc" />
    </div>
  );
};
